export const VALIDATION_MESSAGES = {
  required: (label) =>
    `${label} is required`,

  minLength: (label, min) =>
    `${label} must be at least ${min} characters long`,

  maxLength: (label, max) =>
    `${label} must not exceed ${max} characters`,

  invalid: (label) =>
    `Please enter a valid ${label}`,

  passwordFormat:
    "Password must be 13-128 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (@$!%*?&).",

  companyEmail:
    "Please use your company email address. Personal email providers such as Gmail, Yahoo, Outlook, Hotmail, iCloud, Rediff, and Proton Mail are not permitted for company registrations.",
};